export const IntegrationOutlined = (props) => (
  <svg
    width='34'
    height='34'
    viewBox='0 0 34 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...props?.style }}
  >
    <rect x='0.5' y='0.5' width='33' height='33' rx='16.5' stroke='#EF4444' />
    <circle cx='17' cy='17' r='13.3333' fill='#EF4444' />
    <path
      d='M16.3681 12.0999L22.0358 17.7428C20.353 19.4147 17.8799 22.0592 14.9521 19.1444C12.0243 16.2294 14.6853 13.7718 16.3681 12.0999Z'
      fill='white'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12 22L15.6719 18.4497'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 11L18 13'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M23 14L21 16'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
